import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { addDays, endOfDay } from 'date-fns';
import config from 'utils/config';
import { getAnnouncementHeadingId } from 'utils/announcement/getHeadingId';
import { getHasAnnouncement } from 'utils/announcement/getHasAnnouncement';
import { useFetchMySharedContent, useFetchMyFeaturedContent, useFetchMyUpcomingContent } from 'actions/content';
import { useFetchMyBrowsePlaylists, useFetchMyRecommendedPlaylists } from 'actions/playlists';
import { useFetchBrowseTopics } from 'actions/topics';
import { useFetchAnnouncements } from 'actions/announcements';
import Button from 'components/Button';
import PageSection from 'components/PageSection';
import LandmarkLink from 'components/LandmarkLink';
import PageTitle from 'components/PageTitle';
import AnnouncementBanner from 'components/AnnouncementBanner';
import { DEFAULT_INCLUDED_ORDERED_HOME_SECTION_IDS } from 'types/homeSections';
import HelixOnlyAccessWrapper from './HelixOnlyAccessWrapper';
import HomeSection from './HomeSection';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function Home() {
  var _config$homeSections;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchAnnouncement = useFetchAnnouncements({
      limit: 1
    }),
    items = _useFetchAnnouncement.items;
  var announcement = items === null || items === void 0 ? void 0 : items[0];
  var sectionOrder = (_config$homeSections = config.homeSections) !== null && _config$homeSections !== void 0 ? _config$homeSections : DEFAULT_INCLUDED_ORDERED_HOME_SECTION_IDS;
  var isSectionIncluded = function isSectionIncluded(id) {
    return sectionOrder.includes(id);
  };
  var topicsDisplayType = config.topicsDisplayType === 'buttons' ? 'buttons' : 'tiles';
  var hasTopicsOnHome = isSectionIncluded('topics');
  var _useFetchBrowseTopics = useFetchBrowseTopics({
      enabled: hasTopicsOnHome && isSectionIncluded('topics')
    }),
    data = _useFetchBrowseTopics.data;
  var _ref = data || {
      subtopics: []
    },
    topics = _ref.subtopics;
  var _useFetchMyFeaturedCo = useFetchMyFeaturedContent({
      enabled: isSectionIncluded('featured')
    }),
    featured = _useFetchMyFeaturedCo.items;
  var _useFetchMySharedCont = useFetchMySharedContent({
      enabled: isSectionIncluded('shared')
    }),
    shared = _useFetchMySharedCont.items;
  var upcomingEndDate = endOfDay(addDays(new Date(), config.upcomingTimelineDays || 14)).toISOString();
  var _useFetchMyUpcomingCo = useFetchMyUpcomingContent({
      page: 1,
      limit: 10,
      enabled: isSectionIncluded('upcoming'),
      endDate: upcomingEndDate
    }),
    upcoming = _useFetchMyUpcomingCo.items;
  var _useFetchMyBrowsePlay = useFetchMyBrowsePlaylists({
      sort: 'trending',
      duration: 30,
      limit: 10,
      enabled: isSectionIncluded('trending')
    }),
    trending = _useFetchMyBrowsePlay.items;
  var _useFetchMyBrowsePlay2 = useFetchMyBrowsePlaylists({
      sort: 'last_viewed',
      limit: 10,
      enabled: isSectionIncluded('recentlyViewed')
    }),
    lastViewed = _useFetchMyBrowsePlay2.items;
  var _useFetchMyBrowsePlay3 = useFetchMyBrowsePlaylists({
      sort: 'latest',
      limit: 10,
      enabled: isSectionIncluded('recentlyAdded')
    }),
    latest = _useFetchMyBrowsePlay3.items;
  var _useFetchMyBrowsePlay4 = useFetchMyBrowsePlaylists({
      sort: 'random',
      limit: 10,
      enabled: isSectionIncluded('recommendations')
    }),
    randomRecommendations = _useFetchMyBrowsePlay4.items,
    randomRecommendationsLoading = _useFetchMyBrowsePlay4.isLoading;
  var _useFetchMyRecommende = useFetchMyRecommendedPlaylists({
      enabled: isSectionIncluded('recommendations')
    }),
    recommendations = _useFetchMyRecommende.items,
    recommendationsLoading = _useFetchMyRecommende.isLoading;
  var userRecommendations = !config.recommendations || !(recommendations !== null && recommendations !== void 0 && recommendations.length) && !recommendationsLoading && !randomRecommendationsLoading ? randomRecommendations : recommendations;
  var hasAnnouncement = getHasAnnouncement(announcement);
  var announcementLabelId = announcement && getAnnouncementHeadingId(announcement === null || announcement === void 0 ? void 0 : announcement.id);
  var sectionHasData = {
    featured: Boolean(featured === null || featured === void 0 ? void 0 : featured.length),
    upcoming: Boolean(upcoming === null || upcoming === void 0 ? void 0 : upcoming.length),
    shared: Boolean(shared === null || shared === void 0 ? void 0 : shared.length),
    topics: hasTopicsOnHome && topics.length > 0,
    trending: Boolean(trending === null || trending === void 0 ? void 0 : trending.length),
    recommendations: Boolean(userRecommendations === null || userRecommendations === void 0 ? void 0 : userRecommendations.length),
    recentlyViewed: Boolean(lastViewed === null || lastViewed === void 0 ? void 0 : lastViewed.length),
    recentlyAdded: Boolean(latest === null || latest === void 0 ? void 0 : latest.length)
  };
  var firstCarouselId = sectionOrder.find(function (id) {
    return id !== 'topics' && sectionHasData[id];
  });
  var sectionData = {
    featured: featured,
    upcoming: upcoming !== null && upcoming !== void 0 ? upcoming : [],
    shared: shared,
    topics: topics,
    topicsDisplayType: topicsDisplayType,
    trending: trending,
    recommendations: userRecommendations,
    recentlyViewed: lastViewed,
    recentlyAdded: latest
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageTitle, {
      visuallyHidden: true,
      children: t('navbar_home')
    }), hasAnnouncement && /*#__PURE__*/_jsx(PageSection, {
      "aria-labelledby": announcementLabelId,
      children: /*#__PURE__*/_jsx(AnnouncementBanner, {
        announcement: announcement,
        isDismissable: true
      })
    }), sectionOrder.filter(function (id) {
      return sectionHasData[id];
    }).map(function (id) {
      return /*#__PURE__*/_jsx(HomeSection, {
        id: id,
        isFirstCarousel: id === firstCarouselId,
        data: sectionData
      }, id);
    }), Object.values(sectionHasData).some(Boolean) && /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(LandmarkLink, {
        icon: "topic",
        headingLevel: "h2",
        title: t('my_learning_browse_cta_title'),
        button: /*#__PURE__*/_jsx(Button, {
          as: NavLink,
          to: "/browse",
          variant: "primary",
          children: t('actions_browse_all_playlists')
        }),
        children: /*#__PURE__*/_jsx("p", {
          children: t('my_learning_browse_cta_content')
        })
      })
    })]
  });
}
function ProtectedHome() {
  return /*#__PURE__*/_jsx(HelixOnlyAccessWrapper, {
    children: /*#__PURE__*/_jsx(Home, {})
  });
}
export default ProtectedHome;